module.exports = __webpack_public_path__ + "img/6aa47c1.png";